import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 고객별 리드타임(고객>품목상위그룹>품목그룹>품목별 LT-bucket 크로스탭) — AnalysisController#getCustomerLeadTime.
// PlanResult류의 "날짜+주차/월" 2단 그룹 피벗이 아니라 LT-bucket 헤더 1개당 컬럼 1개(flat)이고,
// 응답 row에 `<header>_BASE_LT_FLAG`(boolean) companion 필드가 같이 내려온다. changes(FilterParameter)를
// 백엔드가 안 읽으므로 postParams만 쓴다 — old도 그리드 조회(loadData)/차트 드릴다운(loadChartData)
// 둘 다 같은 엔드포인트를 customerCd/itemParentGrpCd/itemGrpCd/itemCd 필터값만 다르게 호출한다.
const getCustomerLeadTimes = (params) => fpApiUtil.postParams(`${ANALYSIS}/customer-lead-time`, params);

const fpCustomerLeadTimeService = { getCustomerLeadTimes };
export default fpCustomerLeadTimeService;
